export const environment = {
  production: false,
  appId: '13c153ae-87b8-4c00-ac07-1cfef53ed29e',
  auth: {
    domain: 'auth-test.allegion.com',
    clientId: '5CgDBuwNZ7UlEg1mij62aBeDVdLmpUZR',
    audience: 'https://aat-im-dev-api.com',
    useRefreshTokens: true,
    roleClaimNameSpace: 'http://allegion.com/claims/roles',
    redirectUri: 'https://dev.satidentity.com/callback'
  },
  urlMapping: {
    "AAT_IM_API": 'https://api.dev.satidentity.com/api/'
  }
};
